import styled, { keyframes } from 'styles/styled';

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.4); opacity: 0.55; }
  100% { transform: scale(1); opacity: 1; }
`;

export const Belt = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #15191E;
  border-radius: 10px;
  flex: 0 0 auto;
`;

export const TName = styled.div`
  font-size: 12px;
  color: #A7A8B2;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;

  b {
    color: #EFEFEF;
    font-weight: 700;
  }
`;

export const Countdown = styled.span<{ $urgent?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${(p) => (p.$urgent ? 'rgba(255, 103, 130, 0.06)' : 'rgba(82, 211, 129, 0.06)')};
  border: 1px solid ${(p) => (p.$urgent ? 'rgba(255, 103, 130, 0.18)' : 'rgba(82, 211, 129, 0.18)')};
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  color: ${(p) => (p.$urgent ? '#FF6782' : '#EFEFEF')};
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(p) => (p.$urgent ? '#FF6782' : '#52D381')};
    animation: ${pulse} 1200ms ease-in-out infinite;
  }
`;

export const MyRank = styled.div`
  font-size: 11px;
  color: #7A7E8C;
  font-weight: 500;
  white-space: nowrap;

  b {
    color: #52D381;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
`;
